// Helpers for the client-user restricted mode. GET /user returns
// `client_access` — the user's client-account grants with role
// viewer|manager. The backend may ship it as an array of grant objects or a
// map keyed by client_id; normalize both into [{ client_id, role,
// client_account_uid }].

export function normalizeClientAccess(userData) {
  const raw = userData?.client_access;
  if (!raw) {
    return [];
  }

  let entries = [];
  if (Array.isArray(raw)) {
    entries = raw;
  } else if (typeof raw === "object") {
    entries = Object.entries(raw).map(([clientId, value]) => {
      if (typeof value === "string") {
        return { client_id: clientId, role: value };
      }
      return { client_id: clientId, ...value };
    });
  }

  return entries
    .map((entry) => ({
      client_id: entry.client_id || "",
      role: entry.role === "manager" ? "manager" : "viewer",
      client_account_uid: entry.client_account_uid || null,
    }))
    .filter((entry) => entry.client_id);
}

// A "client user" is logged in without admin rights but with at least one
// client-account grant; they get the File Browser only.
export function isClientUser(userData) {
  return !userData?.is_admin && normalizeClientAccess(userData).length > 0;
}

export function roleForClient(userData, clientId) {
  if (userData?.is_admin) {
    return "manager";
  }
  const grant = normalizeClientAccess(userData).find(
    (entry) => entry.client_id === clientId,
  );
  return grant ? grant.role : null;
}
